<template>
    <CList :pConfigList="ConfigList" :segurity="segurity">
	<template slot="bodyForm">
		<CLoader :pConfigLoad="ConfigLoad">
		<template slot="BodyFormLoad">
            <form id="FormAsignacion" role="form" method="post" autocomplete="off" onSubmit="return false">
                <div class="row mt-3">
                    <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
                        <div class="form-group row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                <label class="col-form-label"><strong>Instrucciones:</strong></label>
                                <label class="col-form-label"><strong>•</strong> Peso max de 2 megas, en formato jpg.</label>
                                <label class="col-form-label"><strong>•</strong> Resoluciones recomendadas para una visualización adecuada en el pdf: </label>
                                <ul>
                                    <li><label>(Arriba) resolución de 960x935 pixeles</label></li>
                                    <li><label>(Abajo) resolución de 960x935 pixeles</label></li>
                                    <li><label>(Izquierda) resolución de 960x455 pixeles </label></li>
                                </ul>
                            </div>
                        </div>
                        
                        
                    </div>

                    <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <div class="avatar-upload">
                                            <div class="avatar-edit">
                                                <input type="file" @change="$uploadImagePreview($event,ValidElement, Array('Img','imagePreview1'))" id="file1" name="file1" ref="fileImg1" accept=".png, .jpg, .jpeg">
                                                <label for="file1"></label>
                                            </div>
                                            <div class="avatar-preview">
                                                <div id="imagePreview1" :style="'background-image: url('+RutaFile+objImagenContrato.Imagen1+')'" :src="RutaFile+objImagenContrato.Imagen1">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="avatar-upload">
                                            <div class="avatar-edit">
                                                <input type="file" @change="$uploadImagePreview($event,ValidElement, Array('Img','imagePreview2'))" id="file2" name="file2" ref="fileImg2" accept=".png, .jpg, .jpeg">
                                                <label for="file2"></label>
                                            </div>
                                            <div class="avatar-preview">
                                                <div id="imagePreview2" :style="'background-image: url('+RutaFile+objImagenContrato.Imagen2+')'" :src="RutaFile+objImagenContrato.Imagen2">
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <div class="avatar-upload">
                                    <div class="avatar-edit">
                                        <input type="file" @change="$uploadImagePreview($event,ValidElement, Array('Img','imagePreview3'))" id="file3" name="file3" ref="fileImg3" accept=".png, .jpg, .jpeg">
                                        <label for="file3"></label>
                                    </div>
                                    <div class="avatar-preview">
                                        <div id="imagePreview3" :style="'background-image: url('+RutaFile+objImagenContrato.Imagen3+')'" :src="RutaFile+objImagenContrato.Imagen3">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <br>
                <div>
                    <CBtnSave v-if="segurity.Save" :poBtnSave="oBtnSave" />
                </div>

            </form>
        </template>
		</CLoader>
	</template>
	</CList>
</template>

<script>

import moment from 'moment';

import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionAsignarPersonal';

export default {
    name: 'ListaCliente',
    props: ['pObjEnviado'],
    components: {
    },
    data() {
        return {
            ConfigList:{
                Title: 'Imagenes del Contrato: ',
                IsModal: false,
                BtnReturnShow: true,
				EmitSeccion: EmitEjecuta,
                BtnNewShow: false,
                TitleFirst: 'Tipo de Evento',
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
            },
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            oBtnSave:{
                toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'tipoEvento',
                EmitSeccion: EmitEjecuta,
            },
            objImagenContrato: {
                IdImagenContrato: 0,
                Imagen1: '',
                Imagen2: '',
                Imagen3: '',
                IdEmpresa: '',
                IdSucursal: '',
                IdTipoEvento: 0,
            },
            segurity: {},
            errorvalidacion: [],
            ObjTipoEvento: {},
            ValidElement: Configs.validImage2m,
            RutaFile: '',
            Img: null,
        }
    },
    methods: {
        async Guardar()
        {
            let formData = new FormData();
            let Imagen1 = this.$refs.fileImg1.files[0];
            let Imagen2 = this.$refs.fileImg2.files[0];
            let Imagen3 = this.$refs.fileImg3.files[0];

            if(Imagen1 === undefined && this.objImagenContrato.IdImagenContrato == 0){
                this.$toast.warning('Debe agregar la imagen 1');
                return false;
            }
            if(Imagen2 === undefined && this.objImagenContrato.IdImagenContrato == 0){
                this.$toast.warning('Debe agregar la imagen 2');
                return false;
            }
            if(Imagen3 === undefined && this.objImagenContrato.IdImagenContrato == 0){
                this.$toast.warning('Debe agregar la imagen 3');
                return false;
            }

			formData.set('IdImagenContrato', this.objImagenContrato.IdImagenContrato);
			formData.set('ImagenOld1', this.objImagenContrato.Imagen1);
			formData.set('ImagenOld2', this.objImagenContrato.Imagen2);
			formData.set('ImagenOld3', this.objImagenContrato.Imagen3);
			formData.set('IdTipoEvento', this.objImagenContrato.IdTipoEvento);

            formData.append('Imagen1',Imagen1);
            formData.append('Imagen2',Imagen2);
            formData.append('Imagen3',Imagen3);
            
			await this.$http.post('imagenesContrato', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.oBtnSave.DisableBtn = false;  
            //this.bus.$emit('RunAlerts_'+EmitEjecuta,1);
            this.$toast.success('Información Guardada');
            this.Lista();
        },
        EjecutaConError(err)
        {
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("imagenesContrato",{
                params:{
					IdTipoEvento: this.ObjTipoEvento.IdTipoEvento,
                }
            }).then((res) => {
                let response = res.data.data;
                console.log(response)
                this.objImagenContrato = response;
                this.RutaFile = res.data.RutaFile;
                this.segurity = res.data.segurity;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute,params:{}});
        },
    },
    created()
    {
        if(this.pObjEnviado != undefined){
            sessionStorage.setItem('objTipoEvento',JSON.stringify(this.pObjEnviado));
        }

        this.ObjTipoEvento = JSON.parse(sessionStorage.getItem('objTipoEvento'));
        this.ConfigList.Title = this.ConfigList.Title+' '+this.ObjTipoEvento.Nombre;
        this.objImagenContrato.IdTipoEvento = this.ObjTipoEvento.IdTipoEvento;
        
        this.bus.$off('Save_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        //this.ConfigLoad.ShowLoader = false;
        this.Lista();
        this.bus.$on('Save_'+EmitEjecuta,()=>
        {
            this.Guardar();
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
